import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import InfoIcon from "@material-ui/icons/Info";

export default function ModalInfo(props) {

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button
        style={{
          backgroundColor: "transparent",
          color: "white",
          border: "white",
          paddingLeft: 2,
        }}
        onClick={toggle}
      >
        <InfoIcon />
      </Button>

      <Modal style={{marginTop: "65px", padding: "15px"}} fullScreen={"lg"} size={"lg"} centered={true} scrollable={true} isOpen={modal} toggle={toggle}>
        <ModalHeader style={{ backgroundColor: "#CED8D7", zIndex: 600}} toggle={toggle}>
          {props.ModalTitle}
        </ModalHeader>
        <ModalBody>{props.ModalBody}</ModalBody>
        <div style={{backgroundColor: "white", height: "3px", color: "transparent"}}><p>filler text</p></div>

        <ModalFooter style={{ backgroundColor: "#CED8D7", height: "25px" }}>
          <br></br>
          {/* <Button color="secondary" onClick={toggle}>
            Close
          </Button> */}
        </ModalFooter>
      </Modal>
    </div>
  );
}
